import UserHistoryTable from "/src/features/administration/user/components/UserTable/UserHistoryTable";
import { useLocation } from 'react-router-dom';
function UserHistoryList() {

    const location = useLocation();
    var data = null;
    if (location.state !=null) {
        data =  location.state.data;
    }

    return <UserHistoryTable data={data}/>
}

export default UserHistoryList;